import {SpinnerJSX} from "../../../../ticketsystem/modules/components/Spinner";
import React from "react";
import {IntlMessage} from "../../../../../@WUM/core/Elements";
import {IntlMessageValue} from "../../../../../@WUM/core/component/const/IntlMessage";
import {DynamikOffCanvas} from "../../../../../@WUM/core/component/const/DynamikModal";
import {WorkLogEntry} from "../../../API/request/ticket.interface";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {ToastFn} from "../../../../worktimetracking/Pages/components/save/SubmitHandler";
import {TimeTrackingCompleteOverviewTable} from "./TimeTrackingCompleteOverviewTable";

interface TimeTrackingCompleteOverviewOffcanvasProps {
    Store: any
    showReportDetail: boolean
    handleCloseReportDetail: () => void
    handleShowReportDetail: () => void
    setShowReportDetail: React.Dispatch<React.SetStateAction<boolean>>;
    users?: responsibilityApiTYpe[] | boolean
    showToast: ToastFn;
}

export const TimeTrackingCompleteOverviewOffcanvas = (props: TimeTrackingCompleteOverviewOffcanvasProps): JSX.Element => {

    const {Store, showReportDetail, handleCloseReportDetail, handleShowReportDetail, setShowReportDetail, users, showToast } = props

    if (typeof users === "boolean") {
        return <SpinnerJSX messageId={'common.loading'} />
    }


    let handlesubmit;
    return (
        <>
            <DynamikOffCanvas
                openButtonLabel={<><span className="material-symbols-outlined ps-2" style={{verticalAlign:'bottom'}}>
                                avg_time
                            </span>
                    <IntlMessage messageId="ticket.button.seeRecords" Store={Store} /></>}
                saveButtonLabel={IntlMessageValue('de', 'common.save', Store)}
                closeButtonLabel={IntlMessageValue('de', 'common.close', Store)}
                title={IntlMessageValue("de","ticket.time.entries",Store)}
                ClassOpenButton={'float-end'}
                ClassSaveButton={'float-end'}
                body={
                    <div className={"mb-3"}>
                        <TimeTrackingCompleteOverviewTable Store={Store} users={users} showToast={showToast} />
                    </div>
                }
                handlesubmit={handlesubmit}
                handleShow={handleShowReportDetail}
                show={showReportDetail}
                id={'TaskNew'}
                setShow={setShowReportDetail}
                handleClose={handleCloseReportDetail}
                noForm={true}
            />
        </>
    )
}